import { Tab, Tabs } from '@material-ui/core';
import React, { useEffect, useReducer, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IntegrationSource from '../../../../../../shared/integration-source/IntegrationSource';
import { updateIRDSyncConfigs } from '../../../../../../utils/PropertyAPIUtils';
import {
  allPropertyConfigsSelector,
  fetchAllPropertyConfigData,
} from '../../../../../property/propertySlice';
import { notificationManager } from '../../../../../../utils/NotificationUtils';
import './InRoomDining.scss';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../../utils/loaderSlice';

const InRoomDining = ({ selectedHotel, showLoader = () => {} }) => {
  const dispatch = useDispatch();
  const propertyConfigs = useSelector(allPropertyConfigsSelector);
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    restaurantSelected: {
      value: '',
      fieldName: 'Select Restaurant',
      errors: {},
      validations: ['required'],
    },
    activeInactive: {
      value: 'Active',
      fieldName: 'activeInactive',
      errors: {},
      validations: [],
    },
    posSelected: {
      value: '',
      fieldName: 'Vendor',
      errors: {},
      validations: [],
    },
    onPrem: {
      value: false,
      fieldName: '',
      errors: {},
      validations: [],
    },
    integrationSource: {
      value: '',
      fieldName: 'Integration Source',
      errors: {},
      validations: [],
    },
    integrationSourceSelected: {
      value: '',
      fieldName: '',
      errors: {},
      validations: [],
    },
    hostingType: {
      value: false,
      fieldName: 'On-Prem Hosting',
      errors: {},
      validations: [],
    },
    rvcId: {
      value: '',
      fieldName: 'RVC ID',
      errors: {},
      validations: ['required'],
    },
    employeeObjectNumber: {
      value: '',
      fieldName: 'Employee Object Number',
      errors: {},
      validations: ['required'],
    },
    posUrl: {
      value: '',
      fieldName: 'URL',
      errors: {},
      validations: ['required'],
    },
  });
  const [tabValue, setTabValue] = useState(0);

  useEffect(() => {
    const posSelected =
      formData.activeInactive.value === 'Active'
        ? { ...formData.posSelected, validations: ['required'] }
        : { ...formData.posSelected, validations: [], value: '' };
    setFormData({ posSelected });
  }, [formData.activeInactive.value]);

  useEffect(() => {
    if (selectedHotel) {
      dispatch(fetchAllPropertyConfigData(selectedHotel));
    }
  }, [selectedHotel]);

  const handleSubmit = async (e) => {
    e.preventDefault();
  };

  const handleTabChange = (event, newValue) => {
    if (newValue < tabValue) {
      setTabValue(newValue);
    } else {
      setTabValue(newValue);
    }
  };

  const onClickSync = async (event) => {
    try {
      dispatch(stepUpLoaderCount());
      const res = await updateIRDSyncConfigs(selectedHotel, event.target.checked);
      dispatch(fetchAllPropertyConfigData(selectedHotel));
      notificationManager(
        res?.data?.updateIRDSyncConfig?.status ? 'success' : 'danger',
        res?.data?.updateIRDSyncConfig?.message,
      );
    } catch (error) {
      if (error) {
        notificationManager('danger', error?.message);
      } else {
        notificationManager('danger', 'Error while sync property config.');
      }
    } finally {
      dispatch(stepDownLoaderCount());
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit} className='restaurant-reservation' noValidate>
        <div className='col-12 hotel-service-tab-section'>
          <div className='col col-xl-6'>
            <Tabs
              value={tabValue}
              variant='fullWidth'
              indicatorColor='primary'
              onChange={handleTabChange}
              aria-label='roomTypes-add-tabs'
              textColor='primary'
              className='property-tabs'
            >
              <Tab label='Integration Settings' />
              <Tab label='Configurable features' />
            </Tabs>
          </div>
        </div>
        {tabValue === 0 && (
          <div className='mx-4'>
            <IntegrationSource
              formData={formData}
              setFormData={setFormData}
              section='In-Room Dining'
              headTitle='POS'
              allowInctive={true}
              onClickSync={onClickSync}
              showLoader={showLoader}
              checked={propertyConfigs?.ird?.isEnabled}
              isSyncEnabled
            />
          </div>
        )}
      </form>
    </>
  );
};

export default InRoomDining;
